import styled from 'styled-components';

interface ILabelRadioProps {
    enabled?: boolean;
}

export const ButtonRadio = styled.span`
    position: absolute;
    top: 0;
    left: 0;
    height: 24px;
    width: 24px;
    background-color: ${(props: ILabelRadioProps) => (props.enabled || props.enabled === undefined) ? "#bdbdbd" : "rgba(189, 189, 189, 0.5)" };
    border-radius: 50%;
`

export const ButtonRadioWhite = styled.span`
    position: absolute;
    top: 1px;
    left: 1px;
    width: 22px;
    height: 22px;
    border-radius: 50%;
    background: white;
    display: block;
`

export const ButtonRadioInside = styled.span`
    position: absolute;
    top: 6px;
    left: 6px;
    height: 12px;
    width: 12px;
    background-color: #ff7319;
    border-radius: 50%;
    display: none;
`

export const InputRadio = styled.input`
    position: absolute;
    opacity: 0;
    cursor: pointer;
    &:checked ~ ${ButtonRadio}{
        background-color: #ff7319;
    }
    &:checked ~ ${ButtonRadioInside}{
        display: block;
    }
`

export const RadioOptions = styled.div`
    font-family: 'Roboto';
    align-items: center;
    line-height: normal;
    letter-spacing: normal;
    text-align: left;
`

export const RadioOption = styled.label`
    padding-right: 35px;
    position: relative;
    padding-left: 35px;
    cursor: pointer;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
`

export const LabelRadio = styled.label`
    margin-top: 1px;
    vertical-align: middle;
    cursor: pointer;
    color: ${(props: ILabelRadioProps) => (props.enabled || props.enabled === undefined) ? "#000000" : "rgba(112, 112, 112, 0.5)" };
`

export const LabelMessage = styled.label`
    margin-top: 1px;
    vertical-align: middle;
    cursor: pointer;
    color: ${(props: ILabelRadioProps) => (props.enabled || props.enabled === undefined) ? "#000000" : "rgba(112, 112, 112, 0.5)" };
`
